import React from "react";

interface ModeRendererProps {
  brand: string;
  today: string;
  Copy: string;
}

export function VasarelyPublicisMode({ brand }: ModeRendererProps) {
  const width = 794;
  const height = 1123;

  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="publicisGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#FF0000", stopOpacity: 1 }} />
          <stop offset="50%" style={{ stopColor: "#CC0000", stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: "#000000", stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <rect width={width} height={height} fill="url(#publicisGradient)" />
      <g transform={`translate(${width / 2}, ${height / 2})`}>
        {Array.from({ length: 20 }).map((_, i) =>
          Array.from({ length: 26 }).map((_, j) => {
            const x = -380 + i * 38;
            const y = -494 + j * 38;
            return (
              <rect
                key={`typo-${i}-${j}`}
                x={x - 16}
                y={y - 16}
                width={32}
                height={32}
                fill="none"
                stroke="#FF0000"
                strokeWidth={1}
                opacity={0.12}
                rx={2}
              />
            );
          })
        )}
        {Array.from({ length: 24 }).map((_, line) => {
          const angle = (line / 24) * 2 * Math.PI;
          const x = Math.cos(angle) * 370;
          const y = Math.sin(angle) * 370;
          return (
            <line
              key={`signal-${line}`}
              x1={0}
              y1={0}
              x2={x}
              y2={y}
              stroke="#FFFFFF"
              strokeWidth={line % 4 === 0 ? 2 : 1}
              opacity={0.2}
              strokeDasharray="8,4"
            />
          );
        })}
        <circle cx={0} cy={0} r={55} fill="none" stroke="#FF0000" strokeWidth={3} opacity={0.6} />
        <circle cx={0} cy={0} r={38} fill="#CC0000" opacity={0.4} />
      </g>
    </svg>
  );
};
